var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "#0C4A6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5527 7.46875V16H10.416L6.12109 9.41992V16H4.99023V7.46875H6.12109L10.4336 14.0664V7.46875H11.5527ZM18.9766 15.0801V16H14.459V15.0801H18.9766ZM14.6875 7.46875V16H13.5566V7.46875H14.6875ZM18.3789 11.1367V12.0566H14.459V11.1367H18.3789ZM18.918 7.46875V8.39453H14.459V7.46875H18.918ZM22.6211 13.4219L24.3145 7.46875H25.1348L24.6602 9.7832L22.8379 16H22.0234L22.6211 13.4219ZM20.8691 7.46875L22.2168 13.3047L22.6211 16H21.8125L19.7441 7.46875H20.8691ZM27.3262 13.2988L28.6445 7.46875H29.7754L27.7129 16H26.9043L27.3262 13.2988ZM25.2578 7.46875L26.9043 13.4219L27.502 16H26.6875L24.9297 9.7832L24.4492 7.46875H25.2578Z",
    fill: "#7DD3FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    stroke: "#0284C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/newIcon.85905c3a90caeeb920f4cc0321249ed3.svg";
export { ForwardRef as ReactComponent };